import { Select, Modal, Button, Row } from "antd";
import { React, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./DashboardHeader.css";
import ButtonComp from "../ButtonComp/ButtonComp";
import {
  trash,
  CheckCircleFilled,
  warning,
  CloseCircleFilled,
} from "../../Utils/imports";
import { deleteRecord } from "../../API-Interaction/apiServices/plantSettings.api";
const HeaderSelects = ({ selectData, isDashboardHeader }) => {
  const { Option } = Select;
  const [deleteModal, setDeleteModal] = useState(false);
  const { current = null} = useSelector(state => state.plant)
  const [selectedOptionName, setSelectedOptionName] = useState("");
  const [valueId, setValueId] = useState('')
  const dispatch = useDispatch();

  let { value, onChange, options, valueLabel, idLabel } = selectData;
  // let formattedOptions = options?.map((option, index) => (
  //         { label: option[valueLabel], value: option[idLabel], data: option }
  //     ))

  let formattedOptions = [];

if (options && Array.isArray(options)) {
  formattedOptions = options.map((option, index) => ({
    label: (
      <div>
        <span>{option[valueLabel]}</span>
        {isDashboardHeader && (  
          <span>
            {idLabel !== "index" &&
              idLabel !== "range" &&
              option[idLabel] !== "addPlantOption" &&
              option[idLabel] !== "addMachineOption" &&
              option[idLabel] !== "addLineOption" && (
                <img
                  src={trash}
                  className="option-image"
                  onClick={(e) => handleDeleteOption(option, e)}
                />
              )}
          </span>
        )}
      </div>
    ),
    value: option[idLabel],
    data: option,
    customLabel: option[valueLabel],
  }));
}

  let types = {
    hallName: 1,
    lineName: 2,
    displayName: 3,
    name: 4,
  };

  const handleDeleteOption = (option, event) => {
    event.stopPropagation();
    setSelectedOptionName(option[valueLabel]);
    setValueId(option[idLabel])
    setDeleteModal(true);
  };

  const DeleteModal = () => (
    <Modal
      title={
        <div className="dflex gap10">
          <img src={warning} style={{ height: "20px", width: "20px" }} />
          <h2>
            {idLabel === "id"
              ? "Delete Line"
              : idLabel === "machineName"
              ? "Delete Machine"
              : "Delete Plant"}
          </h2>
        </div>
      }
      centered
      maskClosable={false}
      footer={null}
      className="deleteModal"
      open={deleteModal}
      width={"30%"}
      onCancel={() => setDeleteModal(false)}
    >
      <Row className="alignCenter justifyCenter gap10">
        <h4
          style={{
            textTransform: "uppercase",
            fontWeight: "bold",
            marginBottom: "20px",
          }}
        >
          Are you sure you want to delete the{" "}
          {idLabel === "id"
            ? "line"
            : idLabel === "machineName"
            ? "machine"
            : "plant"}
          : {selectedOptionName} ?
        </h4>
      </Row>
      <Row className="dflex alignCenter justifyCenter gap10">
        <ButtonComp
          style={{ width: "130px" }}
          theme={"blue"}
          // htmlType="submit"
          text={"Yes"}
          icon={<CheckCircleFilled />}
          onClick={onFinish}
        />
        <ButtonComp
          style={{ width: "130px" }}
          theme={"red"}
          text={"No"}
          icon={<CloseCircleFilled />}
          onClick={handleModalClose}
        />
      </Row>
    </Modal>
  );
  const handleModalClose = () => {
    setDeleteModal(false);
  };
  const onFinish = () => {
    deleteRecord(idLabel, valueId, current, dispatch)
    setDeleteModal(false);
  };

  return (
    <div className="headSelect">
      <Select
        value={formattedOptions?.length ? value : "N/A"}
        className="headSelect_input"
        onChange={(e, values) => onChange(values, dispatch, types[valueLabel])}
        options={formattedOptions}
        optionLabelProp="customLabel"
        dropdownStyle={{ minWidth: "250px" }}
        disabled={formattedOptions?.length ? false : true}
      />
      <DeleteModal />
    </div>
  );
};

export default HeaderSelects;
